import(/* webpackMode: "eager" */ "/app/src/app/(landing)/pricing/page.tsx");
